var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaily(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 805.122,
    height: 744.568,
    viewBox: "0 0 805.122 744.568",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a-115"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 347,
    r: 347,
    transform: "translate(0 -0.037)",
    fill: "#fff",
    stroke: "#e6e6e6",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-566 -108)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(566 158.568)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 347,
    r: 347,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 347,
    r: 345.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(947.744 109)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579.345,259.135H600a2.89,2.89,0,0,1,2.876,2.875v20.663A2.881,2.881,0,0,1,600,285.539h-20.66a2.869,2.869,0,0,1-2.869-2.866V262.011A2.881,2.881,0,0,1,579.345,259.135ZM600,284.611a1.951,1.951,0,0,0,1.948-1.941v-20.66a1.96,1.96,0,0,0-1.95-1.948h-20.65a1.952,1.952,0,0,0-1.948,1.948v20.661a1.941,1.941,0,0,0,1.941,1.939Z",
    transform: "translate(-576.469 -259.135)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.033,297.585H579.381A2.413,2.413,0,0,0,576.969,300v20.661a2.405,2.405,0,0,0,2.412,2.4h20.652a2.411,2.411,0,0,0,2.412-2.4V300a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-576.505 -261.913)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.033,335.535H579.381a2.413,2.413,0,0,0-2.412,2.412V358.6a2.407,2.407,0,0,0,2.412,2.412h20.652a2.413,2.413,0,0,0,2.412-2.412V337.947A2.419,2.419,0,0,0,600.033,335.535Z",
    transform: "translate(-576.505 -264.654)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.408,375.47a2.428,2.428,0,0,0-2.375-1.986H579.381a2.413,2.413,0,0,0-2.412,2.412v20.652a2.407,2.407,0,0,0,2.412,2.412h20.652a2.413,2.413,0,0,0,2.412-2.412V375.9a2.147,2.147,0,0,0-.037-.427Z",
    transform: "translate(-576.505 -267.396)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.97,411.62a2.444,2.444,0,0,0-.937-.186H579.381a2.407,2.407,0,0,0-2.412,2.412V434.5a2.4,2.4,0,0,0,2.412,2.412h20.652a2.414,2.414,0,0,0,2.412-2.412V413.847a2.427,2.427,0,0,0-1.475-2.227Z",
    transform: "translate(-576.505 -270.137)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.793,259.635H626.141a2.413,2.413,0,0,0-2.412,2.412v20.661a2.405,2.405,0,0,0,2.412,2.4h20.652a2.411,2.411,0,0,0,2.412-2.4V262.047a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-579.883 -259.171)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.793,297.585H626.141A2.413,2.413,0,0,0,623.729,300v20.661a2.405,2.405,0,0,0,2.412,2.4h20.652a2.411,2.411,0,0,0,2.412-2.4V300a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-579.883 -261.913)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.793,335.535H626.141a2.413,2.413,0,0,0-2.412,2.412V358.6a2.407,2.407,0,0,0,2.412,2.412h20.652a2.413,2.413,0,0,0,2.412-2.412V337.947a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-579.883 -264.654)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.793,373.485H626.141a2.4,2.4,0,0,0-2.282,1.651,2.3,2.3,0,0,0-.13.761v20.652a2.407,2.407,0,0,0,2.412,2.412h20.652a2.413,2.413,0,0,0,2.412-2.412V375.9A2.42,2.42,0,0,0,646.793,373.485Z",
    transform: "translate(-579.883 -267.396)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.793,411.435H626.141a2.407,2.407,0,0,0-2.412,2.412V434.5a2.407,2.407,0,0,0,2.412,2.412h20.652a2.413,2.413,0,0,0,2.412-2.412V413.847A2.413,2.413,0,0,0,646.793,411.435Z",
    transform: "translate(-579.883 -270.137)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.553,259.635H672.9a2.413,2.413,0,0,0-2.412,2.412v20.661a2.405,2.405,0,0,0,2.412,2.4h20.652a2.411,2.411,0,0,0,2.412-2.4V262.047a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-583.261 -259.171)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.553,297.585H672.9A2.413,2.413,0,0,0,670.489,300v20.661a2.405,2.405,0,0,0,2.412,2.4h20.652a2.411,2.411,0,0,0,2.412-2.4V300a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-583.261 -261.913)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.553,335.535H672.9a2.413,2.413,0,0,0-2.412,2.412V358.6a2.407,2.407,0,0,0,2.412,2.412h20.652a2.413,2.413,0,0,0,2.412-2.412V337.947A2.419,2.419,0,0,0,693.553,335.535Z",
    transform: "translate(-583.261 -264.654)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.553,373.485H672.9a2.413,2.413,0,0,0-2.412,2.412v20.652a2.407,2.407,0,0,0,2.412,2.412h20.652a2.413,2.413,0,0,0,2.412-2.412V375.9A2.419,2.419,0,0,0,693.553,373.485Z",
    transform: "translate(-583.261 -267.396)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.553,411.435H672.9a2.407,2.407,0,0,0-2.412,2.412V434.5a2.407,2.407,0,0,0,2.412,2.412h20.652a2.414,2.414,0,0,0,2.412-2.412V413.847a2.413,2.413,0,0,0-2.412-2.412Z",
    transform: "translate(-583.261 -270.137)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.313,259.635H719.661a2.413,2.413,0,0,0-2.412,2.412v20.661a2.406,2.406,0,0,0,2.412,2.4h20.652a2.411,2.411,0,0,0,2.412-2.4V262.047A2.419,2.419,0,0,0,740.313,259.635Z",
    transform: "translate(-586.639 -259.171)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.625,297.085h20.652a2.89,2.89,0,0,1,2.876,2.875v20.663a2.881,2.881,0,0,1-2.875,2.867h-20.66a2.869,2.869,0,0,1-2.869-2.866V299.961A2.881,2.881,0,0,1,719.625,297.085Zm20.652,25.476a1.951,1.951,0,0,0,1.948-1.941v-20.66a1.96,1.96,0,0,0-1.95-1.948H719.625a1.952,1.952,0,0,0-1.948,1.948v20.661a1.941,1.941,0,0,0,1.941,1.939Z",
    transform: "translate(-586.603 -261.876)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.625,335.035h20.652a2.89,2.89,0,0,1,2.876,2.875v20.653a2.881,2.881,0,0,1-2.876,2.876H719.62a2.852,2.852,0,0,1-2.03-.841,2.891,2.891,0,0,1-.841-2.036V337.911A2.881,2.881,0,0,1,719.625,335.035Zm20.652,25.476a1.952,1.952,0,0,0,1.948-1.948V337.911a1.96,1.96,0,0,0-1.95-1.948h-20.65a1.952,1.952,0,0,0-1.948,1.949v20.652a1.957,1.957,0,0,0,.569,1.379,1.931,1.931,0,0,0,1.374.569Z",
    transform: "translate(-586.603 -264.618)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.313,373.485H719.661a2.413,2.413,0,0,0-2.412,2.412v20.652a2.407,2.407,0,0,0,2.412,2.412h20.652a2.413,2.413,0,0,0,2.412-2.412V375.9A2.419,2.419,0,0,0,740.313,373.485Z",
    transform: "translate(-586.639 -267.396)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.313,411.435H719.661a2.407,2.407,0,0,0-2.412,2.412V434.5a2.408,2.408,0,0,0,2.412,2.412h20.652a2.413,2.413,0,0,0,2.412-2.412V413.847A2.413,2.413,0,0,0,740.313,411.435Z",
    transform: "translate(-586.639 -270.137)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.374,259.135h20.663a2.89,2.89,0,0,1,2.876,2.875v20.663a2.881,2.881,0,0,1-2.875,2.867H766.375a2.871,2.871,0,0,1-2.866-2.867V262.011A2.88,2.88,0,0,1,766.374,259.135Zm20.663,25.476a1.951,1.951,0,0,0,1.948-1.941v-20.66a1.96,1.96,0,0,0-1.95-1.948H766.377a1.951,1.951,0,0,0-1.941,1.948v20.661a1.942,1.942,0,0,0,1.939,1.939Z",
    transform: "translate(-589.981 -259.135)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.374,297.085h20.663a2.89,2.89,0,0,1,2.876,2.875v20.663a2.881,2.881,0,0,1-2.875,2.867H766.375a2.87,2.87,0,0,1-2.866-2.867V299.961A2.88,2.88,0,0,1,766.374,297.085Zm0,25.476h20.662a1.951,1.951,0,0,0,1.948-1.941v-20.66a1.96,1.96,0,0,0-1.95-1.948H766.377a1.951,1.951,0,0,0-1.941,1.948v20.661A1.941,1.941,0,0,0,766.375,322.561Z",
    transform: "translate(-589.981 -261.876)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.374,335.035h20.663a2.89,2.89,0,0,1,2.876,2.875v20.653a2.881,2.881,0,0,1-2.876,2.876H766.376a2.869,2.869,0,0,1-2.867-2.877V337.911A2.88,2.88,0,0,1,766.374,335.035Zm0,25.476h20.661a1.952,1.952,0,0,0,1.948-1.948V337.911a1.96,1.96,0,0,0-1.95-1.948H766.377a1.951,1.951,0,0,0-1.941,1.948v20.652a1.942,1.942,0,0,0,1.939,1.948Z",
    transform: "translate(-589.981 -264.618)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.073,373.485H766.412a2.411,2.411,0,0,0-2.4,2.412v20.652a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V375.9a2.42,2.42,0,0,0-2.412-2.412Z",
    transform: "translate(-590.017 -267.396)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.073,411.435H766.412a2.406,2.406,0,0,0-2.4,2.412V434.5a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V413.847A2.413,2.413,0,0,0,787.073,411.435Z",
    transform: "translate(-590.017 -270.137)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.134,259.135H833.8a2.89,2.89,0,0,1,2.876,2.875v20.663a2.881,2.881,0,0,1-2.875,2.867H813.135a2.87,2.87,0,0,1-2.866-2.867V262.011A2.88,2.88,0,0,1,813.134,259.135ZM833.8,284.611a1.951,1.951,0,0,0,1.948-1.941v-20.66a1.96,1.96,0,0,0-1.95-1.948H813.137a1.951,1.951,0,0,0-1.941,1.948v20.661a1.942,1.942,0,0,0,1.939,1.939Z",
    transform: "translate(-593.359 -259.135)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.134,297.085H833.8a2.89,2.89,0,0,1,2.876,2.875v20.663a2.881,2.881,0,0,1-2.875,2.867H813.135a2.871,2.871,0,0,1-2.866-2.867V299.961A2.88,2.88,0,0,1,813.134,297.085Zm0,25.476H833.8a1.951,1.951,0,0,0,1.948-1.941v-20.66a1.96,1.96,0,0,0-1.95-1.948H813.137a1.951,1.951,0,0,0-1.941,1.948v20.661A1.942,1.942,0,0,0,813.135,322.561Z",
    transform: "translate(-593.359 -261.876)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.833,335.535H813.172a2.411,2.411,0,0,0-2.4,2.412V358.6a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V337.947A2.419,2.419,0,0,0,833.833,335.535Z",
    transform: "translate(-593.395 -264.654)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.833,373.485H813.172a2.412,2.412,0,0,0-2.4,2.412v20.652a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V375.9a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-593.395 -267.396)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.135,410.935H833.8a2.881,2.881,0,0,1,2.876,2.876v20.652a2.881,2.881,0,0,1-2.876,2.876H813.136a2.869,2.869,0,0,1-2.867-2.878V413.811a2.869,2.869,0,0,1,2.866-2.876ZM833.8,436.411a1.952,1.952,0,0,0,1.948-1.949V413.811a1.952,1.952,0,0,0-1.949-1.948h-20.66a1.942,1.942,0,0,0-1.94,1.947v20.653a1.941,1.941,0,0,0,1.939,1.948Z",
    transform: "translate(-593.359 -270.101)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.593,259.635H859.932a2.411,2.411,0,0,0-2.4,2.412v20.661a2.4,2.4,0,0,0,2.4,2.4h20.662a2.411,2.411,0,0,0,2.412-2.4V262.047A2.419,2.419,0,0,0,880.593,259.635Z",
    transform: "translate(-596.773 -259.171)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.593,297.585H859.932a2.411,2.411,0,0,0-2.4,2.412v20.661a2.4,2.4,0,0,0,2.4,2.4h20.662a2.411,2.411,0,0,0,2.412-2.4V300A2.419,2.419,0,0,0,880.593,297.585Z",
    transform: "translate(-596.773 -261.913)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.593,335.535H859.932a2.411,2.411,0,0,0-2.4,2.412V358.6a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V337.947a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-596.773 -264.654)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.894,372.985h20.663a2.89,2.89,0,0,1,2.876,2.875v20.653a2.881,2.881,0,0,1-2.876,2.876H859.9a2.869,2.869,0,0,1-2.867-2.877V375.861A2.881,2.881,0,0,1,859.894,372.985Zm20.663,25.476a1.952,1.952,0,0,0,1.948-1.948V375.861a1.96,1.96,0,0,0-1.95-1.948H859.9a1.951,1.951,0,0,0-1.941,1.948v20.652a1.942,1.942,0,0,0,1.94,1.948Z",
    transform: "translate(-596.737 -267.36)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.593,411.435H859.932a2.405,2.405,0,0,0-2.4,2.412V434.5a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V413.847a2.413,2.413,0,0,0-2.412-2.412Z",
    transform: "translate(-596.773 -270.137)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.353,259.635H906.692a2.411,2.411,0,0,0-2.4,2.412v20.661a2.4,2.4,0,0,0,2.4,2.4h20.662a2.411,2.411,0,0,0,2.412-2.4V262.047A2.419,2.419,0,0,0,927.353,259.635Z",
    transform: "translate(-600.151 -259.171)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.353,297.585H906.692a2.411,2.411,0,0,0-2.4,2.412v20.661a2.4,2.4,0,0,0,2.4,2.4h20.662a2.411,2.411,0,0,0,2.412-2.4V300A2.419,2.419,0,0,0,927.353,297.585Z",
    transform: "translate(-600.151 -261.913)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.353,335.535H906.692a2.411,2.411,0,0,0-2.4,2.412V358.6a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V337.947a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-600.151 -264.654)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.353,373.485H906.692a2.411,2.411,0,0,0-2.4,2.412v20.652a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V375.9a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-600.151 -267.396)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.353,411.435H906.692a2.405,2.405,0,0,0-2.4,2.412V434.5a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V413.847a2.413,2.413,0,0,0-2.412-2.412Z",
    transform: "translate(-600.151 -270.137)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.113,259.635H953.452a2.411,2.411,0,0,0-2.4,2.412v20.661a2.4,2.4,0,0,0,2.4,2.4h20.662a2.411,2.411,0,0,0,2.412-2.4V262.047A2.419,2.419,0,0,0,974.113,259.635Z",
    transform: "translate(-603.529 -259.171)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.113,297.585H953.452a2.411,2.411,0,0,0-2.4,2.412v20.661a2.4,2.4,0,0,0,2.4,2.4h20.662a2.411,2.411,0,0,0,2.412-2.4V300A2.419,2.419,0,0,0,974.113,297.585Z",
    transform: "translate(-603.529 -261.913)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.113,335.535H953.452a2.411,2.411,0,0,0-2.4,2.412V358.6a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V337.947a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-603.529 -264.654)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.113,373.485H953.452a2.411,2.411,0,0,0-2.4,2.412v20.652a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V375.9a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-603.529 -267.396)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.113,411.435H953.452a2.406,2.406,0,0,0-2.4,2.412V434.5a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V413.847a2.413,2.413,0,0,0-2.412-2.412Z",
    transform: "translate(-603.529 -270.137)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.873,259.635h-20.661a2.411,2.411,0,0,0-2.4,2.412v20.661a2.4,2.4,0,0,0,2.4,2.4h20.662a2.411,2.411,0,0,0,2.412-2.4V262.047a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-606.907 -259.171)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.873,297.585h-20.661a2.411,2.411,0,0,0-2.4,2.412v20.661a2.4,2.4,0,0,0,2.4,2.4h20.662a2.411,2.411,0,0,0,2.412-2.4V300A2.419,2.419,0,0,0,1020.873,297.585Z",
    transform: "translate(-606.907 -261.913)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.873,335.535h-20.661a2.411,2.411,0,0,0-2.4,2.412V358.6a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V337.947a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-606.907 -264.654)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.873,373.485h-20.661a2.412,2.412,0,0,0-2.4,2.412v20.652a2.405,2.405,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V375.9a2.419,2.419,0,0,0-2.412-2.412Z",
    transform: "translate(-606.907 -267.396)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.873,411.435h-20.661a2.405,2.405,0,0,0-2.4,2.412V434.5a2.406,2.406,0,0,0,2.4,2.412h20.661a2.413,2.413,0,0,0,2.412-2.412V413.847a2.413,2.413,0,0,0-2.412-2.412Z",
    transform: "translate(-606.907 -270.137)",
    fill: "#d6d6e3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(566 158.605)",
    clipPath: "url(#a-115)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.24 75.739)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 52,
    transform: "translate(182.76 148.224)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.84,809.869q-3.484.083-7,.083c-55.6,0-136.622-18.062-200.085-61.573-5.251-3.6.634-20.654,0-53.552l136.928-19.242L563.411,731.2Z",
    transform: "translate(-236.697 -191.343)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.05,660.046h-.575l.492-.065Z",
    transform: "translate(-79.486 -116.38)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.386,
    cy: 63.386,
    r: 63.386,
    transform: "translate(143.747 31.877)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.221,202.426s16.578-31.693-19.895-34.574c0,0-31.094-28.206-62.787-5.156,0,0-17.287,0-26.74,19.562,0,0-13.6-5.156-16.584,8.644,0,0-9.949,28.812,0,54.743s13.253,28.812,13.253,28.812-16.348-54.365,23.444-57.246,84.321-27.749,87.637,3.944,8.306,39.5,8.306,39.5S545.353,215.392,507.221,202.426Z",
    transform: "translate(-244.579 -153.636)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.877,419.227l-.2,1.076-2.292,12.1-15.837,83.684-.937,4.926-1.967,10.419-2.69,14.213-5.966,31.5-1.707,9.027-.64,3.386-.223,1.188-1.772,9.343-.538,2.82-4.323,32.035V666.9l-3.618,44.445.009.065-211.336-2.846c-8.164-5.288-17.291-58.191-11.3-107.715l-.037-.77-.51-10.53-.065-1.355-.1-2.032-1.958-40.525-.037-.668-.594-12.284-.557-11.68-.241-4.926-2.384-49.292-1.614-33.473-1.41-29.141,5.669-1.92,60.629-20.606L429.441,349l52.27.39,25.588.195,42.7,39.6,9.714,4.639.074.037,6.967,3.331,17.664,8.433,18.676,8.925,9.584,4.574Z",
    transform: "translate(-241.778 -167.75)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.2,631.4a28.1,28.1,0,0,1-37.726-20.81l-98.861-14.026,34.367-38.875,88.611,19.279A28.25,28.25,0,0,1,433.2,631.4Z",
    transform: "translate(-238.786 -182.826)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.622,548.6a12.546,12.546,0,0,0-7.32-4.518l-40.562-8.433-4.166-.863a17.565,17.565,0,0,1-11.625-8.415,17.776,17.776,0,0,1-2.273-7.329,17.529,17.529,0,0,1,.826-6.94l14.056-42.352,9.12-27.48a38.775,38.775,0,0,0,1.939-10.252,40.217,40.217,0,0,0-8.415-26.8,39.609,39.609,0,0,0-45.469-12.655c-.232.084-.473.176-.705.269a39.507,39.507,0,0,0-23.482,26.358l-9.908,36.043-20.439,74.3a53.593,53.593,0,0,0,45.423,67.429l58.421,6.847,27.035,3.173a12.522,12.522,0,0,0,13.768-9.955,4.536,4.536,0,0,0,.1-.51l.65-4.008,5.5-33.752.056-.343A12.5,12.5,0,0,0,384.622,548.6Z",
    transform: "translate(-234.283 -170.706)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510,631.5a28.1,28.1,0,0,0,34.415-25.922l95.895-27.827L600.8,544.109l-85.007,31.582A28.25,28.25,0,0,0,510,631.5Z",
    transform: "translate(-252.609 -181.845)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.124,503.235,646.515,398.268a39.726,39.726,0,0,0-18.806-19.808,40.228,40.228,0,0,0-8.146-2.969c-.436-.111-.872-.213-1.308-.3a39.088,39.088,0,0,0-18.073.334,39.721,39.721,0,0,0-25.365,20.16.922.922,0,0,0-.074.13,39.986,39.986,0,0,0-.343,36.044l.566,1.132,32.23,64.73a17.535,17.535,0,0,1-9.741,24.3l-2.264.817-40.71,14.7a12.522,12.522,0,0,0-7.728,15.577l.1.325,11.411,36.516c.056.167.111.334.176.5a6.558,6.558,0,0,0,.371.918,12.508,12.508,0,0,0,14.668,6.986l21.969-5.8,4.481-1.188L656.665,576.4a53.588,53.588,0,0,0,35.459-73.163Z",
    transform: "translate(-256.814 -169.577)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.446,608.285c8.514,16.192,11.264,31.2,26.383,45.386H683.113a15.258,15.258,0,0,1,15.234,15.243l.6,106.256a329.75,329.75,0,0,0,71.873-45.024q9.129-7.5,17.692-15.651,5.608-5.316,10.948-10.892c26.686-27.8,57.488-60.06,73.041-95.318Z",
    transform: "translate(-234.945 -186.481)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.956,711.025q-5.33,5.581-10.947,10.892h-89.26V711.025Z",
    transform: "translate(-270.438 -193.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.943,335.325a5.138,5.138,0,0,0-4.518-2.69H300.269a5.153,5.153,0,0,0-5.14,5.149V519.829H609.574V337.784a5,5,0,0,0-.631-2.459Z",
    transform: "translate(-238.679 -166.568)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.832,529.092v22.465a7.092,7.092,0,0,0,7.092,7.092H417.983v44.334h-1.542a.921.921,0,0,0-.921.921v3.083a.921.921,0,0,0,.921.921H488.49a.921.921,0,0,0,.921-.921V603.9a.921.921,0,0,0-.921-.921h-1.542V558.649h116.06a7.092,7.092,0,0,0,7.092-7.092V529.092Z",
    transform: "translate(-238.658 -180.76)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.045,
    cy: 29.045,
    r: 29.045,
    transform: "translate(180.954 225.766)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.335,247.033H523.7c0-35.069-34.707-58.05-69.721-58.068a76.43,76.43,0,0,0-15.169,1.475c-5.622,1.123-11.458,2.468-17.191,4.221-22.609,6.93-43.577,20.327-43.577,52.372a72.911,72.911,0,0,0,2.356,18.444l-4.49,1.169a77.815,77.815,0,0,1-2.5-19.613c0-28,11.495-47.232,31.349-58.7,10.437-6.03,23.175-9.918,37.769-11.81a90.114,90.114,0,0,1,18.323-.557C501.1,178.861,528.335,209.737,528.335,247.033Z",
    transform: "translate(-244.333 -155.233)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.63,253.309,544.8,239.8a14.764,14.764,0,0,0-16.932-12.58l-2.9.4a6.106,6.106,0,0,0-5.232,6.865l4.221,31.117a6.1,6.1,0,0,0,4.917,5.168,5.712,5.712,0,0,0,1.132.111,6.029,6.029,0,0,0,.815-.055l3.248-.436a14.651,14.651,0,0,0,9.964-5.965c.25-.353.492-.714.714-1.086A15.539,15.539,0,0,0,546.63,253.309Z",
    transform: "translate(-254.901 -158.939)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.225,253.612,546.4,240.1a14.575,14.575,0,0,0-4.639-8.869l4.2,30.959a5.73,5.73,0,0,0,.38,1.447,15.538,15.538,0,0,0,1.883-10.029Z",
    transform: "translate(-256.496 -159.242)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.288,284.638l-7.144-29.7a5.589,5.589,0,0,0-4.527-4.221,6.247,6.247,0,0,0-.928-.074,5.59,5.59,0,0,0-1.3.158l-2.765.668a13.827,13.827,0,0,0-10.2,16.663l3.2,13.323a14.7,14.7,0,0,0,4.954,8,13.028,13.028,0,0,0,1.262.9,13.74,13.74,0,0,0,10.549,1.707l2.755-.668a5.418,5.418,0,0,0,2.013-.937A5.56,5.56,0,0,0,394.288,284.638Z",
    transform: "translate(-243.874 -160.644)",
    fill: "#7FE7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.043,262.978a6.009,6.009,0,0,0-1.085-2.273,13.662,13.662,0,0,0-.529,8.155l3.2,13.323a14.7,14.7,0,0,0,4.954,8Z",
    transform: "translate(-243.874 -161.371)",
    fill: "#090814"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaily);
export default __webpack_public_path__ + "static/media/daily.d93cb67e9e73f32f22878d1fa0a2a83e.svg";
export { ForwardRef as ReactComponent };